module.exports = __webpack_public_path__ + "static/media/logo.fe4e99cd.svg";